import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// Import custom components
import * as actions from './actions';
import * as services from './services';
import * as optionsService from '../../../components/shared/Options/services';
import * as optionsActions from '../../../components/shared/Options/actions';
import * as customFieldService from '../../../components/shared/CustomField/services';
import * as customFieldActions from '../../../components/shared/CustomField/actions';
import * as applicationServices from '../../dashboard/services';
import LandingPageForm from './component';

const LandingPageContainer = (props) => {
  /**
   * Update basic information.
   * @param {object} formData
   *
   */
  const updateLandingPage = (formData) => {
    return props.actions.updateLandingPage(formData);
  };

  /**
   * Fetch basic information
   * @param {object} formData
   *
   */
  const fetchLandingPage = (formData) => {
    props.actions.fetchLandingPage(formData);
  };

  /**
   * Fetch application information
   *
   */
  const fetchApplicationStatus = () => {
    props.actions.fetchApplicationStatus();
  };

  /**
   * Clean basic records.
   *
   */
  const cleanLandingPage = () => {
    props.actions.basicInfoCleanRequest();
  };

  /**
   * Fetch select options data
   * @param {string} optionType
   * @param {string} optionName
   * @param {string} parentCode optional
   *
   */
  const fetchOptionList = (optionType, optionName, parentCode) => {
    props.actions.fetchOptionList(optionType, optionName, parentCode);
  };

  /**
   * Clean role records.
   *
   */
  const cleanOptions = () => {
    props.actions.optionsCleanRequest();
  };

  /**
   * Fetch customized field records.
   * @param {object} formData
   *
   */
  const fetchCustomField = (formData) => {
    props.actions.fetchCustomField(formData);
  };

  /**
   * Clean custom field records.
   *
   */
  const cleanCustomField = () => {
    props.actions.customFieldCleanRequest();
  };

  /**
   * Fetch application information
   *
   */
  const getDraftDetailBasicInfo = (formData) => {
    return props.actions.getDraftDetailBasicInfo(formData);
  };

  const requestDraftDetailBasicInfo = (formData) => {
    return props.actions.requestDraftDetailBasicInfo(formData);
  };

  return (
    <LandingPageForm
      updateLandingPage={updateLandingPage}
      fetchLandingPage={fetchLandingPage}
      cleanLandingPage={cleanLandingPage}
      cleanOptions={cleanOptions}
      fetchOptionList={fetchOptionList}
      fetchCustomField={fetchCustomField}
      cleanCustomField={cleanCustomField}
      fetchApplicationStatus={fetchApplicationStatus}
      requestDraftDetailBasicInfo={requestDraftDetailBasicInfo}
      {...props}
    />
  );
};

/**
 * Map the state to props.
 */
const mapStateToProps = (state) => ({
  landingPage: state.landingPage.payload,
  landingPageErrors: state.landingPage.errors,
  landingPageLoading: state.landingPage.loading,
  options: state.options.payload,
  optionsErrors: state.options.errors,
  optionsLoading: state.options.loading,
  fields: state.fields.payload,
});

/**
 * Map the actions to props.
 */
const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      Object.assign(
        {},
        actions,
        services,
        optionsService,
        optionsActions,
        customFieldService,
        customFieldActions,
        applicationServices
      ),
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LandingPageContainer);
